/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import { Card, CardBody, Col, Row, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import CountUp from "react-countup";
import { useSelector } from "react-redux";

const CountUpComponent = ({ end }) => {
  const [endValue, setEndValue] = useState(0);

  useEffect(() => {
    setEndValue(end);
  }, [end]);

  return <CountUp start={0} end={endValue} duration={3} />;
};

const Widget = ({ widget }) => {
  const widgetConfig = {
    id: widget.id,
    label: widget.label,
    badge: widget.badgeIcon,
    counter: widget.counter,
    separator: ",",
  };

  return (
    <Col xl={3} md={6}>
      <Card>
        <CardBody style={{ height: "100px", overflow: "hidden" }}>
          <div className="d-flex align-items-center counter-widget">
            <div className="flex-grow-1">
              <p className="text-uppercase fw-semibold fs-14 text-muted mb-1">
                {widgetConfig.label || "data"}
              </p>
              <h2 className="mb-0 mr-2">
                <CountUpComponent end={widgetConfig.counter || 0} />
              </h2>
            </div>
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                <i className={"align-middle " + (widgetConfig.badge || "las la-chart-bar")}></i>
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

const TileBoxs = () => {
  const [activeTab, setActiveTab] = useState("statistics");

  const dashboardData = useSelector((state) => 
    state?.Analytics?.dashboardData || 
    state?.analytics?.dashboardData || 
    state?.dashboard?.dashboardData || 
    state?.dashboardData || 
    {}
  );

  const usersData = dashboardData?.users || {};

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const widgetData = useMemo(
    () => [
      {
        id: 1,
        label: "Total Users",
        badgeIcon: "las la-users",
        counter: usersData.total || 0,
      },
      {
        id: 2,
        label: "Today Users",
        badgeIcon: "las la-user-plus",
        counter: usersData.today || 0,
      },
      {
        id: 3,
        label: "Week Users",
        badgeIcon: "las la-user-clock",
        counter: usersData.week || 0,
      },
      {
        id: 4,
        label: "Deleted Users",
        badgeIcon: "las la-user-times",
        counter: usersData.deleted || 0,
      },
    ],
    [usersData]
  );

  return (
    <React.Fragment>
      <TabContent activeTab={activeTab} className="mt-3">
        <TabPane tabId="statistics">
          <Row>
            {widgetData.length > 0 ? (
              widgetData.map((widget) => <Widget key={widget.id} widget={widget} />)
            ) : (
              <Col>
                <p className="text-center">No widget data available.</p>
              </Col>
            )}
          </Row>
        </TabPane>
      </TabContent>
    </React.Fragment>
  );
};

export default TileBoxs;